import { groupChart, seriesChart } from './helper/helperHighcharts'

export const ChartOptions = ({ state, widget, height }): Highcharts.Options => {
    const { group = [], events, attr, select = [] } = state || {}
    const { jsonConfig } = widget || {}
    const { borderRadius = 7, pointWidth = 20, showCurrentDay, maxScrollbarItems, scrollbar, description } = jsonConfig
    
    const categories = groupChart(events, [group]) || []

    const uniqEvents = Object.keys(
        events.reduce((acc, val) => {
            acc[val[group]] = acc[val[group]] === undefined ? 1 : (acc[val[group]] += 1)
            return acc
        }, {})
    ).length

    const plotLinesH = categories
        .filter(function(category) {
            return category.includes('__')
        })
        .map(category => {
            if (category.includes('__')) {
                const index = categories.indexOf(category)
                return {
                    zIndex: 5,
                    dashStyle: 'Solid',
                    color: '#C8CCD4',
                    width: 1,
                    value: index - 0.5
                }
            }
        })

    return {
        chart: {
            type: 'columnrange',
            inverted: true,
            height: (maxScrollbarItems / height + (64 + 32)) * uniqEvents,
            events: {
                load: function() {
                    // if (!scrollbar) {
                    const chart = this
                    let yAxisMin = chart.yAxis[0].dataMin
                    chart.update({
                        yAxis: {
                            min: yAxisMin
                        }
                    })
                    // }
                }
                //     const chart = this
                //     console.log('chart this', this)
                //     // console.log('chart', this.xAxis[0])
                //     // console.log("chart", this.xAxis[0].labelGroup.element)
                //     let xAxisMin = chart.xAxis[0].dataMin,
                //         xAxisMax = chart.xAxis[0].dataMax,
                //         yAxisMin = chart.yAxis[0].dataMin,
                //         yAxisMax = chart.yAxis[0].dataMax
                //     console.log("yAxisMin", yAxisMin, "xAxisMin",xAxisMin)
                //     chart.update({
                //         // xAxis: {
                //             // min: xAxisMin
                //             // max: xAxisMax,
                //         // },
                //         yAxis: {
                //             min: yAxisMin,
                //             max: yAxisMax
                //         }
                //     })
                // }
            }
        },
        time: {
            timezone: 'America/Sao_Paulo'
        },
        title: {
            text: ''
        },
        credits: {
            enabled: false
        },

        yAxis: {
            maxPadding: 0,
            type: 'datetime',
            title: {
                text: ''
            },
            //TODO: create logic for better tick interval depending on data

            // minTickInterval: 6000,//28 * 24 * 3600 * 1000,
            // tickInterval: 600000,//000,
            // dateTimeLabelFormats: {
            //     minute: '%H:%M',
            //     day: '%H:%M'
            // },

            plotLines: showCurrentDay
                ? [
                      {
                          zIndex: 5,
                          dashStyle: 'LongDash',
                          color: '#FF0000',
                          width: 1,
                          value: Date.now() //.getTime()
                          //   value: new Date.now()//.getTime()
                      }
                  ]
                : []
        },
        xAxis: {
            tickLength: 0,
            categories: [...categories],
            plotLines: plotLinesH,
            // endOnTick: false,
            // startOnTick: false,
            // margin: [0, 0, 0, 0],
            // padding: [0, 0, 0, 0],
            labels: {
                align: 'right',
                reserveSpace: true,
                formatter: function(a) {
                    let isDivisor
                    try {
                        isDivisor = this?.value?.includes('__')
                    } catch (e) {
                        isDivisor = false
                    }

                    if (isDivisor && typeof this.value === 'string') {
                        return (
                            '<span x=43 style="fill: #364159; font-weight: 600; transform: translate(5,0)">' +
                            this.value.replace('__', '').replace(/#.*/, '') +
                            '</span>'
                        )
                        // return (
                        //     '<span style="fill: #364159; font-weight: 600; transform: translate(5,0)">' +
                        //     this.value.replace('__', '') +
                        //     '</span>'
                        // )
                    } else if (typeof this.value === 'string') {
                        return '<span  style="fill: #868695;">' + this.value.replace(/#.*/, '') + '</span>'
                    }
                }
            }
        },
        legend: {
            enabled: false
        },
        tooltip: {
            formatter: function() {
                if (this.point.isNull) return 'Null'
                const { name, pointFormat = '' } = this.point || {}
                return `<b>${pointFormat.replace(/#.* /, ' ') || name}</b>`
            }
            // backgroundColor: '#364159',
            // borderColor: '',
            // borderRadius: 10,
            // borderWidth: 3,
            // shadow: false,
            // shared: false,
            // useHTML: true,
            // valueSuffix: '°C'
            // headerFormat: '<b>{point.x}</b>',
            // pointFormat: '{point.name}'
        },

        plotOptions: {
            columnrange: {
                grouping: true,
                pointPadding: 0,
                dataLabels: {
                    inside: true,
                    enabled: true,
                    useHTML: false,
                    align: 'center',
                    formatter: function() {
                        const { labelPoint = '' } = this.point
                        return labelPoint
                    }
                }
            },
            series: {
                borderRadius: borderRadius,
                pointWidth: pointWidth,
                stacking: 'normal',
                borderWidth: 0,
                pointPadding: 0,
                groupPadding: 0
                // grouping: false,
                // stacking: 'normal',
                // pointPadding: 0,
                // groupPadding: 0.0,
                // allowPointSelect: false,
                // dataLabels: {
                //     enabled: true,
                //     align: 'center',
                //     x: -10,
                //     formatter: function() {
                //         return this.series.name
                //     }
                // }
            }
        },
        series: seriesChart(attr, events, select, group, categories)
    }
}
